import type { UserRole } from '@utazzo/shared';

/**
 * Who sees the bulk "Assign to agent" controls: the Unassigned queue, the lead
 * detail inbox aside and the Lead Parsing grid. Admins and sales leads only -
 * the same roles that may change a lead's owner (LeadOwnerChanger). Each
 * endpoint re-checks the role server-side; this only hides what would 403.
 */
export const canBulkAssignLeads = (role: UserRole | null | undefined): boolean =>
  role === 'ADMIN' || role === 'SALES_LEAD';
